import { List } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isLogin } from "../../../Store/Actions/AuthAction";
import Card from "../../../components/Card/Card";

import { GoDotFill } from "react-icons/go";
import { CusAssetsMiddleware } from "../../../Store/Middlewares/CusAssetsMiddleware";
import imagePlaceholder from "../../../assets/images/imageplace.jpg";
import { TextComponent } from "../../../components";
import Switch from "../../../components/Switch/Switch";
import BatteryStatus from "../../../components/battery/Battery";
import ResetPassword from "../../Auth/ResetPasswrd";
import styles from "./userDashboard.module.css";
const UserDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const DASHBOARD = useSelector(
    (state) => state?.CusAssetsReducer?.getCusDashboard,
  );
  useEffect(() => {
    dispatch(CusAssetsMiddleware.getCusDashboard({ name: "" }));
  }, []);

  const onLogout = () => {
    dispatch(isLogin(false));
    navigate("/");
  };

  const assets = [
    {
      name: "Family SUV - Phoenix Immobilizer",
      image: require("../../../assets/images/staticImages/c6.png"),
      status: "Disconnected",
      battery: 85,
      mobilized: false,
    },
    {
      name: "Family SUV - Phoenix Immobilizer",
      image: require("../../../assets/images/staticImages/c6.png"),
      status: "Connected",
      battery: 85,
      mobilized: false,
    },
  ];

  const activeSchedule = [
    {
      name: "My Car - Device 1",
      title: "Immobilizer Activation",
      time: "Daily, 10:00 AM",
      isActive: true,
    },
    {
      name: "Family SUV - Device 2",
      title: "Immobilizer health check",
      time: "Daily, 08:00 AM",
      isActive: false,
    },
    {
      name: "Family SUV - Device 3",
      title: "Immobilizer health check",
      time: "Daily, 08:00 AM",
      isActive: false,
    },
  ];

  const Inventory = [
    {
      name: "Phoenix Immobilizer N16",
      image: require("../../../assets/images/staticImages/p1.png"),
      version: "1.0.5",
      drive: true,
      car: "Asset: Toyota 2023",
      shared: "James gun",
    },
    {
      name: "Phoenix Immobilizer N16",
      image: require("../../../assets/images/staticImages/p2.png"),
      version: "1.0.5",
      drive: false,
      car: "Asset: Toyota 2023",
      shared: "James gun",
    },
  ];

  const notifications = [
    {
      title: "Low Device Inventory Alert ",
      desc: "Security system triggered due to an unauthorized vehicle access attempt.",
      isRead: true,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "An unauthorized attempt to access your vehicle was detected. Immobilizer activated.",
      isRead: false,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "Please check your vehicle's security settings for any alerts or issues.",
      isRead: false,
      time: "2 min ago",
    },
    {
      title: "Low Device Inventory Alert ",
      desc: "Security system triggered due to an unauthorized vehicle access attempt.",
      isRead: true,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "An unauthorized attempt to access your vehicle was detected. Immobilizer activated.",
      isRead: false,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "Please check your vehicle's security settings for any alerts or issues.",
      isRead: false,
      time: "2 min ago",
    },
    {
      title: "Low Device Inventory Alert ",
      desc: "Security system triggered due to an unauthorized vehicle access attempt.",
      isRead: true,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "An unauthorized attempt to access your vehicle was detected. Immobilizer activated.",
      isRead: false,
      time: "2 min ago",
    },
    {
      title: "Order Shipped",
      desc: "Please check your vehicle's security settings for any alerts or issues.",
      isRead: false,
      time: "2 min ago",
    },
  ];

  const renderAssets = (item, index) => {
    return (
      <div className={styles.assetCont} style={{ padding: 20 }} key={index}>
        <div
          className={
            item.status == "drive"
              ? styles.mobilizedCont
              : styles.immobilizedCont
          }
        >
          <GoDotFill
            size={15}
            color={
              item.status == "drive"
                ? "var(--primary-color)"
                : "var(--green-color)"
            }
          />
          <TextComponent text={item?.status ? item?.status : "immobilized"} />
        </div>
        <img
          src={item?.image ? item?.image : imagePlaceholder}
          alt=""
          className={styles.assetImg}
        />
        <div className={styles.descCont}>
          <TextComponent text={item?.name} className={styles.prodName} />
          <div className={styles.statusCont}>
            <TextComponent text={"Connected via LoRaWAN"} />
            <BatteryStatus
              percentage={parseFloat(
                item?.battery_volt
                  ? (item?.battery_volt / 12) * 100
                  : (12 / 12) * 100,
              ).toFixed(0)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderModules = (item, index) => {
    return (
      <div
        className={styles.productCont}
        style={{ justifyContent: "space-between" }}
      >
        <div className={styles.productRightCont}>
          <img src={item?.image} alt="" className={styles.prodImg} />
          <div className={styles.descCont}>
            <TextComponent text={item?.name} className={styles.prodName} />
            <TextComponent text={"Firmware Version: "}>
              <TextComponent text={item?.version} className={styles.version} />
            </TextComponent>
            <TextComponent text={item?.car} />
            <div className={styles.switchCont}>
              <TextComponent text={"Immobilized"} />
              <Switch
                // label="Enable Feature"
                size="small"
                disabled
                activeColor={"var(--primary-color)"}
                inactiveColor={"var(--green-color)"}
                initialChecked={item.drive}
                isChecked={item.drive}
                // onChange={handleSwitchChange} // Pass callback function
              />
              {/* <Switch
                value={item.drive}
                style={
                  item.drive ? { backgroundColor: "var(--primary-color)" } : {}
                }
                // onChange={() => {}}
                // disabled
              /> */}
            </div>
          </div>
        </div>
        <TextComponent text={`Access shared by: ${item?.shared}`} />
        {/* <div>
          <TextComponent text={"Drive "} />
          <Switch
            value={item.drive}
            style={item.drive ? { backgroundColor: "var(--green-color)" } : {}}
            onChange={() => {}}
            disabled
          />
        </div> */}
      </div>
    );
  };

  const renderNotification = (item, index) => {
    return (
      <div className={styles.productCont}>
        <div className={styles.productRightCont}>
          <div>
            <GoDotFill
              size={30}
              color={
                !item?.is_read == 1
                  ? "var(--secondary-color)"
                  : "var(--primary-color)"
              }
            />
          </div>
          <div className={styles.descCont}>
            <TextComponent
              text={item?.title ? item?.title : "--"}
              className={styles.prodName}
            />
            <TextComponent text={item.description ? item.description : "--"} />
            <TextComponent text={item?.time_ago} className={styles.readTime} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.mainCont}>
        <div className={styles.leftCol}>
          <Card className={styles.salesCard}>
            <TextComponent
              text="Active Schedules"
              className={styles.headerHead}
            />
            <div className={styles.stockDetail}>
              {DASHBOARD?.activeSchedules?.slice(0, 3)?.map((item, index) => (
                <div
                  className={`${styles.saleCont} ${
                    index == 0 ? styles.activeCont : ""
                  }`}
                  key={index}
                >
                  <TextComponent
                    text={item?.parent_name}
                    className={`${styles.name} ${styles.bold}`}
                  />
                  <TextComponent text={item?.name} className={styles.name} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <TextComponent
                      text={
                        item?.frequency == "one_time" ? "One time:" : "Daily:"
                      }
                      className={styles.name}
                    /> */}
                    <TextComponent
                      text={item?.start_time}
                      className={`${styles.name} ${styles.bold}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Card>
          <Card>
            <div className={styles.orderMainCont}>
              <TextComponent text="Alerts" className={styles.headerHead} />
              {DASHBOARD?.assets?.length > 5 && (
                <TextComponent
                  text="See All"
                  className={styles.seeAll}
                  onClick={() => navigate("/notifications")}
                />
              )}
            </div>
            <List
              className={styles?.notificationCont}
              dataSource={DASHBOARD?.alerts}
              renderItem={renderNotification}
            />
          </Card>
          {/* <Card>
          <div className={styles.orderMainCont}>
            <TextComponent text="Modules" className={styles.headerHead} />
            <TextComponent text="See All" className={styles.seeAll} onClick={()=>navigate("/module")} />
          </div>
          <List dataSource={Inventory} renderItem={renderModules} />
        </Card> */}
        </div>
        <div className={styles.rightCol}>
          <Card>
            <div className={styles.orderMainCont}>
              <TextComponent text="Assets" className={styles.headerHead} />
              {DASHBOARD?.assets?.length > 2 && (
                <TextComponent
                  text="See All"
                  className={styles.seeAll}
                  onClick={() => navigate("/userAssets")}
                />
              )}
            </div>
            <List
              dataSource={DASHBOARD?.assets?.slice(0, 2)}
              renderItem={renderAssets}
            />
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserDashboard;
